import React from 'react'

const NoDataChart = ({title, subtitle}) => {
  return (
    
    <React.Fragment>
        <div  className='h-100 p-5 d-flex flex-column justify-content-center align-items-center' style={{minHeight:"320px"}}>

        {title && <h4 className="text-center">{title}</h4>}
        {subtitle && <p className="text-center">{subtitle}</p>}
        </div>
    </React.Fragment>
  )
}

export default NoDataChart